import React, { useRef, useState } from 'react';
import cn from 'classnames';
import SortableList from '../SortableList';
import SortableIcon from '../SortableIcon';

import isArray from 'isarray';
import arrayMove from 'array-move';
import './styles.scss';
const flat = (arr) => arr.reduce((acc, curr) => acc.concat(curr), []);

export default function ({
  nodes,
  currentItemReference,
  onDragEnd = () => {},
  onIconClick = () => {},
}) {
  const rootWrapperElement = useRef(null);
  const [innerNodes, setInnerNodes] = useState(nodes);
  const [refs] = useState(flat(nodes));

  const handleDragEnd = (e, childIndex, items) => {
    let res = [];

    // if we have childIndex it means we move inside group
    const hasChild = childIndex !== null;

    if (hasChild) {
      const child = arrayMove(
        items[childIndex],
        e.oldDraggableIndex,
        e.newDraggableIndex,
      );
      res = items.slice();
      res[childIndex] = child;
    } else {
      res = arrayMove(items, e.oldDraggableIndex, e.newDraggableIndex);
    }

    // pass stimulus id as childIndex
    onDragEnd(
      e.oldDraggableIndex,
      e.newDraggableIndex,
      hasChild
        ? res[childIndex][e.newDraggableIndex]
        : res[e.newDraggableIndex],
      flat(res),
    );
    setInnerNodes(res);
  };

  return (
    <div ref={rootWrapperElement}>
      <SortableList
        nodes={innerNodes}
        className={cn('question-list all-overview-icons')}
        options={{ group: 'root' }}
        onDragEnd={(e, nodes) => {
          handleDragEnd(e, null, nodes);
        }}
      >
        {innerNodes.map((node, index) => {
          if (isArray(node)) {
            return (
              <SortableList
                showDecor
                key={node}
                nodes={innerNodes}
                container={rootWrapperElement}
                className="all-overview-icons__connected"
                onDragEnd={(e, nodes) => handleDragEnd(e, index, nodes)}
                options={{
                  group: `children-${node}`,
                }}
              >
                {node.map((child) => (
                  <SortableIcon
                    key={`icon-${child}`}
                    isSelected={child === currentItemReference}
                    index={refs.indexOf(child)}
                    reference={child}
                    onClick={onIconClick}
                  />
                ))}
              </SortableList>
            );
          }
          return (
            <SortableIcon
              key={`icon-${node}`}
              isSelected={node === currentItemReference}
              index={refs.indexOf(node)}
              reference={node}
              onClick={onIconClick}
            />
          );
        })}
      </SortableList>
    </div>
  );
}
